import { CanDeactivateFn } from "@angular/router";
import { EnrichmentEditPackage } from "../components/edit/enrichment-edit-package/enrichment-edit-package";

/**
 * CanDeactivate guard for the editor. The editor decides: it asks about
 * unsaved edits with its one Save & continue / Discard / Stay prompt and
 * answers exactly one boolean. The route runs this on a `:popId` change too
 * (`runGuardsAndResolvers: "paramsChange"`), so a sibling switch, a package
 * change, Cancel, the Enrichment menu and the browser's Back all take the
 * same path.
 */
export const enrichmentDirtyGuard: CanDeactivateFn<EnrichmentEditPackage> = (
  component,
) => component.confirmUnsavedEdits();
